export default (variants, check) => variants.map(([label, variant]) => ({
  label,
  apply: (collection) => collection.filter(item => check(item, variant))
}))
